import type { CSSProperties } from 'react';

import { convertPercentInPixels } from 'hb-builder/utils/migrate/utils/convertPercentInPixels';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

export const transformContainerPadding = (
  item: DocumentItem,
  referenceWidth: `${number}%`,
  bodyWidth: CSSProperties['width'],
) => {
  const isWidthPercentage = (width: unknown): width is `${number}%` =>
    typeof width === 'string' && width.includes('%');
  const width: unknown = item?.attributes?.width || referenceWidth;

  if (
    item?.attributes?.containerPadding &&
    item?.attributes?.containerPadding?.includes('%') &&
    isWidthPercentage(width)
  ) {
    return {
      ...item,
      attributes: {
        ...item.attributes,
        containerPadding: convertPercentInPixels(
          (+width / 100) * parseInt(width, 10),
          item.attributes.containerPadding,
        ),
      },
      children: item?.children?.map((child) =>
        transformContainerPadding(child, width, bodyWidth),
      ),
    };
  }

  return item;
};
